var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100%"}},[_c('v-card',{staticClass:"d-flex flex-column justify-content-center align-items-center",attrs:{"elevation":"0","height":"100%","width":"100%"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"50"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }